import { LoadingSkeleton, tokens } from 'ComponentLibrary'
import { Stack } from '@mui/material'

export const TaskOverViewPageLoading = () => (
    <Stack direction="column" gap={tokens.SizingSpacing050}>
        <Stack direction="row" gap={tokens.SizingSpacing050}>
            <LoadingSkeleton count={7} width="100%" height="28px" sx={{ transform: 'none' }} />
        </Stack>
        <LoadingSkeleton count={6} height="38px" sx={{ transform: 'none' }} />
        <Stack direction="row" gap={tokens.SizingSpacing050} paddingTop={tokens.SizingSpacing075} alignSelf="flex-end">
            <LoadingSkeleton width="32px" height="32px" sx={{ transform: 'none' }} />
            <LoadingSkeleton width="78px" height="32px" sx={{ transform: 'none' }} />
            <LoadingSkeleton width="32px" height="32px" sx={{ transform: 'none' }} />
        </Stack>
    </Stack>
)
